import { render, staticRenderFns } from "./CandidateLogMessagesBlock.vue?vue&type=template&id=df3b92be&scoped=true&"
import script from "./CandidateLogMessagesBlock.vue?vue&type=script&lang=js&"
export * from "./CandidateLogMessagesBlock.vue?vue&type=script&lang=js&"
import style0 from "./CandidateLogMessagesBlock.vue?vue&type=style&index=0&id=df3b92be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3b92be",
  null
  
)

/* custom blocks */
import block0 from "./CandidateLogMessagesBlock.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateLogMessagesBlock.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
